import { theme } from '@approvalmax/theme';
import { Button, TextEditor } from '@approvalmax/ui';
import { font } from 'modules/styles';
import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
`;

export const cardStyles = css`
    display: flex;
    flex-flow: column;
    max-width: 100%;
    width: 400px;
    min-height: 240px;
    background: #fff;
    padding: 40px 50px 50px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        padding: 40px 15px 50px;
        max-width: calc(100vw - 20px);
    }
`;

export const Card = styled.div`
    ${cardStyles}
    border-radius: 8px;
`;

export const CardForm = styled.form`
    ${cardStyles}
    border-radius: 8px;
`;

export const Title = styled.div`
    ${font(16, '#000', 'semibold')}
    text-align: center;
`;

export const InvisibleSubmit = styled.input`
    position: absolute;
    opacity: 0;
    left: -9999px;
    top: -9999px;
`;

export const CentralBlock = styled.div`
    position: relative;
    flex: 1;
    flex-direction: column;
    margin-top: 30px;
    display: flex;
`;

export const StyledTextEditor = styled(TextEditor)`
    margin-bottom: 20px;
`;

export const ValidationMessage = styled.div`
    position: absolute;
    top: 31px;
    right: 0;
    ${font(13, '#923924', 'semibold')}
    pointer-events: none;
    z-index: 1;
`;

export const SignupButton = styled(Button)`
    min-height: 40px;
`;

export const SuccessIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 34px;
    margin-bottom: 24px;
`;

export const SuccessComment = styled.div`
    text-align: center;
    ${font(13, '#000')}
`;

export const BottomBlock = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    margin-top: 20px;
`;
